import { toPng } from 'html-to-image';

/**
 * Télécharge un élément de la page en image PNG (html-to-image : rendu dans le navigateur, rien côté API).
 * Résolution doublée pour rester net à l'impression ; fond blanc (sinon transparent).
 */
export async function downloadPng(node: HTMLElement, fileName: string): Promise<void> {
  const dataUrl = await toPng(node, { pixelRatio: 2, backgroundColor: '#ffffff', cacheBust: true });
  const link = document.createElement('a');
  link.download = fileName;
  link.href = dataUrl;
  link.click();
}
